<template>
  <span class="place-row-title">
    {{ place.name }}
  </span>
  <span class="verification-label">
    <!-- place is verified -->
    <span v-if="place.is_verified">
      <font-awesome-icon
        class="verified-icon"
        :icon="['fas', 'check-circle']"
      />
      {{ $t("placeRow.verifiedLabel") }}
    </span>
    <!-- place is not verified -->
    <span v-if="!place.is_verified && place.validation_status != 'inprocess'">
      <font-awesome-icon
        class="not-verified-icon"
        :icon="['fas', 'exclamation-circle']"
      />
      {{ $t("placeRow.notVerifiedLabel", { users: usersNumber }) }}
    </span>
  </span>
  <div class="place-row-content">
    <div
      class="alert alert-primary"
      role="alert"
      v-if="place.validation_status == 'inprocess'"
    >
      {{ $t("placeRow.beingReviewed") }}
    </div>
    <div
      class="alert alert-warning"
      role="alert"
      v-if="place.validation_status == 'stopped'"
    >
      {{ $t("placeRow.wasStopped") }}
    </div>
    <span class="place-row-address">
      <font-awesome-icon :icon="['fas', 'map-pin']" />&nbsp;
      {{ place.line_address }}
    </span>
    <br />
    <a :href="'place/' + place.uid">{{ $t("placeRow.seeDetailsLink") }}</a>
    <!-- <span class="place-row-next-payment" v-if="place.is_verified">
      <br />
      {{
        $t("placeRow.nextPaymentDate", {
          paymentDate: getNextPaymentDate(place.last_validation_date),
        })
      }}
    </span> -->
    <div class="place-row-btns">
      <!-- <button
        class="btn btn-primary place-row-btn place-row-details-btn"
        @click="goToPlaceDetails(place.uid)"
      >
        <font-awesome-icon :icon="['fas', 'info']" /> &nbsp;
        {{ $t("placeRow.openDetailsBtn") }}
      </button> -->
      <!-- <button
        class="btn btn-primary place-row-btn place-row-pdf-btn"
        v-if="place.is_verified"
      >
        <font-awesome-icon :icon="['fas', 'file']" />&nbsp;
        {{ $t("placeRow.pdfBtn") }}
      </button> -->
      <button
        class="btn btn-primary place-row-btn place-row-verify-btn"
        v-if="
          !place.is_verified &&
            place.validation_status != 'inprocess' &&
            place.validation_status != 'stopped'
        "
        @click="goToPlaceDetails(place.uid)"
      >
        <font-awesome-icon :icon="['fas', 'check-circle']" />&nbsp;
        {{ $t("placeRow.verifyBtn") }}
      </button>
    </div>
    <hr />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilsService from "@/services/UtilsService";
const utilsService = new UtilsService();
import router from "@/router";

export default defineComponent({
  name: "PlaceRow",
  props: {
    place: Object,
    usersNumber: Number,
  },
  setup(props) {
    console.log("setup with props", props.place);
  },
  methods: {
    /**
     * Go to details of a place
     */
    goToPlaceDetails: async (placeId: string) => {
      console.log("go to details of a place FROM component", placeId);
      router.push(`/place/${placeId}`);
    },

    // return next payment date
    getNextPaymentDate(lastPaymentDate: number) {
      return utilsService.getNextPaymentDate(lastPaymentDate, false, true);
    },
  },
});
</script>

<style></style>
